"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var classnames_1 = __importDefault(require("classnames"));
var React = __importStar(require("react"));
var Text_module_scss_1 = __importDefault(require("./Text.module.scss"));
/**
 * @deprecated Text is deprecated. Use Paragraph or Heading instead.
 */
var Text = function (_a) {
    var _b;
    var tag = _a.tag, children = _a.children, _c = _a.inheritBaseline, inheritBaseline = _c === void 0 ? false : _c, _d = _a.inline, inline = _d === void 0 ? false : _d, _e = _a.style, style = _e === void 0 ? "default-style" : _e;
    return React.createElement(tag, {
        className: (0, classnames_1["default"])(Text_module_scss_1["default"][style], (_b = {},
            _b[Text_module_scss_1["default"].inheritBaseline] = inheritBaseline,
            _b[Text_module_scss_1["default"].inline] = inline,
            _b))
    }, children);
};
Text.displayName = "Text";
exports["default"] = Text;
//# sourceMappingURL=Text.js.map